import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import config from '../../../../../common-sk-doc/src/config';
// import { Translate } from '../../../hooks/Translater';

const ErrorAppNew: React.FC<any> = ({ error, resetErrorBoundary }) => {
  return (
    <>
      <div className="header-wrapper">
        <div className="header container">
          <a href="/" className="logo">
            <img
              className="me-2"
              src={config.ASSETS_PATH + '/logo192.svg'}
              alt={'Học liệu thông minh' /*Translate('courseware', 'Học liệu')*/}
              height={45}
            />
          </a>
        </div>
      </div>
      <div className="text-center py-5 my-5 px-3 mx-3">
        <div>
          <h3>
            <b>{'Đã có lỗi xảy ra' /*Translate('an-error-has-occurred', 'Đã có lỗi xảy ra')*/}</b>
          </h3>

          <div className="text-warning my-4">
            <FontAwesomeIcon icon={faExclamationTriangle} size="5x" />
          </div>
          <div>
            <Button onClick={resetErrorBoundary}>
              {'Quay lại trang trước' /*Translate('back-to-previous-page', 'Quay lại trang trước')*/}
            </Button>
            <Button
              className="ms-2"
              onClick={() => (window.location.href = '/')}>
              {'Về trang chủ' /*Translate('to-homepage', 'Về trang chủ')*/}
            </Button>
          </div>
          <h5 className="mt-4">
            <b>
              {
                'Hãy kiểm tra kết nối internet của bạn và thử'
                // Translate(
                //   'please-check-your-internet-connection-and-try',
                //   'Hãy kiểm tra kết nối internet của bạn và thử',
                // )
              }{' '}
              <Link
                to="#"
                onClick={() => {
                  window?.location.reload();
                }}>
                {'tải lại trang' /*Translate('reloading-the-page', 'tải lại trang')*/}
              </Link>
            </b>
          </h5>
        </div>

        <div className="mt-4">
          {
            'Nếu đây không phải lỗi đường truyền, mong bạn hãy báo lỗi tới đội ngũ'
            // Translate(
            //   'if-this-is-not-a-transmission-error-please-report-the-error-to',
            //   'Nếu đây không phải lỗi đường truyền, mong bạn hãy báo lỗi tới đội ngũ',
            // )
          }
          <br />

          {
            'để sự cố được khắc phục trong thời gian sớm nhất.'
            // Translate(
            //   'so-that-the-problem-can-be-fixed-as-soon-as-possible',
            //   'để sự cố được khắc phục trong thời gian sớm nhất.',
            // )
          }
        </div>
        <div className="mt-2">
          <b>{'Xin cảm ơn!' /*Translate('thank-you!', 'Xin cảm ơn!')*/}</b>
        </div>
      </div>
    </>
  );
};

export default ErrorAppNew;
